"use client";

import { CallToAction } from "@/components/marketing/CallToAction";
import { FAQ } from "@/components/marketing/FAQ";
import { FooterSection } from "@/components/marketing/FooterSection";
import { Separator } from "@/components/ui/separator";
import { Hero } from "./Hero";
import LogoTicker from "./LogoTicker";
import NavBar from "./Nav";
import { ProblemSection } from "./ProblemSection";
import { CapabilitiesSection } from "./CapabilitiesSection";
import { LandfastInActionSection } from "./LandfastInActionSection";
import { ResumeTemplatesSection } from "./ResumeTemplatesSection";

export default function Home() {
  return (
    <main className="relative isolate min-h-screen overflow-hidden text-slate-900 dark:text-slate-100">
      <div className="pointer-events-none fixed inset-0 -z-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#eef2ff] via-white to-[#e0f2fe] dark:from-[#040713] dark:via-[#050d24] dark:to-[#020515]" />
        <div
          className="absolute inset-0 dark:hidden"
          style={{
            backgroundImage:
              "radial-gradient(ellipse 46rem 42rem at 68% -15%, rgba(79,70,229,0.2), transparent 72%), radial-gradient(ellipse 52rem 48rem at -8% 62%, rgba(56,189,248,0.15), transparent 72%), radial-gradient(ellipse 48rem 44rem at 72% 120%, rgba(236,72,153,0.14), transparent 72%)",
          }}
          aria-hidden
        />
        <div
          className="absolute inset-0 hidden dark:block"
          style={{
            backgroundImage:
              "radial-gradient(ellipse 46rem 42rem at 68% -15%, rgba(129,140,248,0.25), transparent 72%), radial-gradient(ellipse 52rem 48rem at -8% 62%, rgba(14,165,233,0.2), transparent 72%), radial-gradient(ellipse 48rem 44rem at 72% 120%, rgba(244,114,182,0.2), transparent 72%)",
          }}
          aria-hidden
        />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-[120rem] flex-col gap-16 px-5 sm:px-8 lg:px-14">
        <NavBar />
        <Hero />
        <section className="relative overflow-hidden rounded-[2.5rem] px-6 lg:px-12">
          <div
            className="pointer-events-none absolute right-12 -z-10 h-72 w-72 rounded-full"
            aria-hidden
          />
          <LogoTicker />
        </section>
        <ProblemSection />
        <CapabilitiesSection />
        <LandfastInActionSection />

        <ResumeTemplatesSection />

        <FAQ />
        {/* <TestimonialsSection /> */}
        <CallToAction />
        <Separator className="border-slate-200/60 dark:border-white/5" />
        <FooterSection />
      </div>
    </main>
  );
}
